module.exports = __webpack_public_path__ + "static/img/7.b181971b.png";